import * as React from 'react';
import './UserLink.scss';
import { FunctionComponent } from 'react';
import { PROFILE_ROUTE } from '../utils/consts';
import { Link } from 'react-router-dom';

export interface UserLinkProps {
  id: number,
  fullName: string,
  countryCode: string,
  userActive: boolean,
  profileLinkVisible: boolean,
  openInNewTab?: boolean // when set to 'true', means that link will be opened in new tab
}

const UserLink: FunctionComponent<UserLinkProps> = ({id, fullName, countryCode, userActive, profileLinkVisible, openInNewTab = false}) => {

  if (userActive && profileLinkVisible) {
    return (
      <div className='userLink_wrap'>
        <Link
          to={`${PROFILE_ROUTE}/${id}`}
          {...(openInNewTab && { target: '_blank', rel: 'noopener noreferrer' })}
        >{fullName}</Link>
        <div>{countryCode}</div>
      </div>
    );
  } else if (!userActive && profileLinkVisible) {
    return (
      <Link
        to={`${PROFILE_ROUTE}/${id}`}
        {...(openInNewTab && { target: '_blank', rel: 'noopener noreferrer' })}
      >{fullName} [Inactive]</Link>
    );
  }

  return <div>{fullName} [Inactive]</div>;
};
  

export default UserLink;